import { render } from "./Size.vue?vue&type=template&id=2cb478d7"
import script from "./Size.vue?vue&type=script&lang=js"
export * from "./Size.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/statistics/kingdoms/Size.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cb478d7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cb478d7', __exports__)) {
    api.reload('2cb478d7', __exports__)
  }
  
  module.hot.accept("./Size.vue?vue&type=template&id=2cb478d7", () => {
    api.rerender('2cb478d7', render)
  })

}


export default __exports__